import { render, staticRenderFns } from "./TeamTasks.vue?vue&type=template&id=4ce41906&scoped=true&lang=pug&"
import script from "./TeamTasks.vue?vue&type=script&lang=js&"
export * from "./TeamTasks.vue?vue&type=script&lang=js&"
import style0 from "./TeamTasks.vue?vue&type=style&index=0&id=4ce41906&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ce41906",
  null
  
)

export default component.exports